import React from "react";
import { useNavigate } from "react-router-dom";
import ChangePasswordFormComponent from "../../components/auth/ChangePasswordFormComponent";
import "./AuthPages.css";

export default function ChangePasswordPage() {
  const navigate = useNavigate();

  return (
    <div className="auth-shell">
      <section className="auth-main">
        <div className="auth-container">
          <div className="auth-header">
            <h1>Change Password</h1>
            <p>Update your password to keep your account secure.</p>
          </div>
          <ChangePasswordFormComponent onSuccess={() => navigate("/")} />
          <p className="auth-copyright">
            © 2026 DecisionFlow. All rights reserved.
          </p>
        </div>
      </section>
      <aside className="auth-side">
        <h2>Account Security</h2>
        <p>
          Use a strong password with a mix of uppercase, lowercase, numbers, and
          symbols.
        </p>
      </aside>
    </div>
  );
}
